import { useState, useEffect } from "react";

function useLoanOfficerStatus(axiosInstance) {
  const [loanOfficer, setLoanOfficer] = useState(null);
  const [loaded, setLoaded] = useState(false);
  const [errorMessage, setErrorMessage] = useState();

  useEffect(() => {
    async function fetchLoanOfficerStatus() {
      try {
        const { data } = await axiosInstance.get(`/public/loan-officers/pwa/status`);
        if (data.valid) {
          setLoanOfficer(data.loanOfficer);
          if (data.loanOfficer.paidPWA) {
            localStorage.setItem("userId", data.loanOfficerUID);
          } else {
            localStorage.removeItem("userId");
            setErrorMessage("You need to contact Loan Officer for access");
          }
        } else {
          setErrorMessage("No loan officer with such id");
        }
      } catch (e) {
        setErrorMessage(e.message);
      } finally {
        setLoaded(true);
      }
    }
    fetchLoanOfficerStatus();
  }, []); // eslint-disable-line

  return { loanOfficer, loaded, errorMessage };
}

export default useLoanOfficerStatus;
